import {
  COMMAND_PRIORITY_EDITOR,
  FORMAT_TEXT_COMMAND,
  LexicalEditor,
  createCommand,
} from 'lexical';
import * as Constants from 'const';

export const REFERENCES_FONT_COMMAND = {
  CHAR_STYLE: createCommand<Constants.CharStyle>(),
} as const;

export function registerCommands(
  editor: LexicalEditor,
): () => void {
  return editor.registerCommand(
    REFERENCES_FONT_COMMAND.CHAR_STYLE,
    (style) => {

      if (style === Constants.CharStyle.UNDERLINE) {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');

        return true;
      }

      if (style === Constants.CharStyle.BOLD) {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');

        return true;
      }

      if (style === Constants.CharStyle.ITALIC) {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');

        return true;
      }

      return false;
    },
    COMMAND_PRIORITY_EDITOR,
  );
}
